import {Box, Button, Heading, Text, VStack} from '@chakra-ui/react';
import {useNavigate} from 'react-router-dom';

const NotFoundPage = () => {
    const navigate = useNavigate();

    return (
        <Box
            w="100%"
            h="100vh"
            display="flex"
            justifyContent="center"
            alignItems="center"
            bg="gray.50"
        >
            <VStack spacing={6} textAlign="center">
                <Heading fontSize="6xl" color="gray.700">
                    404
                </Heading>
                <Text fontSize="xl" color="gray.600" fontWeight={'semibold'}>
                    Page Not Found.
                </Text>
                <Text fontSize='lg' color="gray.500" fontWeight={'medium'}>
                    Sorry, we can’t find the page you’re looking for.
                </Text>
                <Button
                    colorScheme="blue"
                    onClick={() => navigate('/admin/dashboard')}
                    px={6}
                    rounded="full"
                >
                    Back to Home
                </Button>
            </VStack>
        </Box>
    );
};

export default NotFoundPage;
